export default "curl -X GET {{url}} -H \"api-key: {{apiKey}}\"\n"